import { safeJsonParse } from './safeJsonParse';

const normalizeText = (value) => {
  const text = String(value ?? '').trim();
  if (!text || text.toLowerCase() === 'none') return '';
  return text;
};

const getImageFileName = (imgName) => {
  const raw = normalizeText(imgName);
  if (!raw) return '';
  if (raw.includes('\\')) return raw.substring(raw.lastIndexOf('\\') + 1);
  if (raw.includes('/')) return raw.split('/').pop();
  return raw;
};

export const parseImgsNamesArray = (rawValue) => {
  if (rawValue == null || rawValue === '' || rawValue === '[]') return [];

  if (Array.isArray(rawValue)) {
    return rawValue.map((name) => getImageFileName(name)).filter(Boolean);
  }

  if (typeof rawValue === 'string') {
    const parsed = safeJsonParse(rawValue, null);
    if (Array.isArray(parsed)) {
      return parsed.map((name) => getImageFileName(name)).filter(Boolean);
    }

    return rawValue
      .split(',')
      .map((name) => getImageFileName(name.replace(/['"[\]]/g, '')))
      .filter(Boolean);
  }

  return [];
};

export const parseImgsSignaturesArray = (rawValue) => {
  if (rawValue == null || rawValue === '' || rawValue === '[]') return [];

  if (Array.isArray(rawValue)) {
    return rawValue.map((signature) => normalizeText(signature));
  }

  if (typeof rawValue === 'string') {
    const parsed = safeJsonParse(rawValue, null);
    if (Array.isArray(parsed)) {
      return parsed.map((signature) => normalizeText(signature));
    }

    return rawValue.split(',').map((signature) => signature.trim());
  }

  return [];
};
